(function () {
  function initQuiz(quiz) {
    const form = quiz.querySelector("[data-quiz-form]");
    const btn = quiz.querySelector("[data-quiz-submit]");
    const reset = quiz.querySelector("[data-quiz-reset]");
    const out = quiz.querySelector("[data-quiz-output]");
    const res1 = quiz.querySelector("[data-result='1']");
    const res2 = quiz.querySelector("[data-result='2']");
    const res3 = quiz.querySelector("[data-result='3']");
    const err = quiz.querySelector("[data-quiz-error]");

    function hideAll() {
      out.style.display = "none";
      err.style.display = "none";
      res1.style.display = "none";
      res2.style.display = "none";
      res3.style.display = "none";
    }

    function showResult(which) {
      hideAll();
      out.style.display = "block";
      const map = { "1": res1, "2": res2, "3": res3 };
      map[String(which)].style.display = "block";
      out.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function getMajority(values) {
      const counts = { 1: 0, 2: 0, 3: 0 };
      values.forEach(v => counts[v]++);
      const max = Math.max(counts[1], counts[2], counts[3]);
      const winners = [1, 2, 3].filter(k => counts[k] === max);

      // Si égalité, on choisit le "milieu" (2) si présent, sinon 1
      if (winners.length > 1) return winners.includes(2) ? 2 : 1;
      return winners[0];
    }

    btn.addEventListener("click", function () {
      const required = Number(quiz.getAttribute("data-questions") || "5");
      const values = [];
      for (let i = 1; i <= required; i++) {
        const checked = quiz.querySelector(`input[name="q${i}"]:checked`);
        if (!checked) {
          hideAll();
          err.style.display = "block";
          err.textContent = "🐾 Oups… réponds à toutes les questions pour obtenir ton verdict amoureux.";
          return;
        }
        values.push(Number(checked.value));
      }
      const majority = getMajority(values);
      showResult(majority);
    });

    reset.addEventListener("click", function () {
      form.reset();
      hideAll();
    });

    hideAll();
  }

  function boot() {
    document.querySelectorAll("[data-af-quiz]").forEach(initQuiz);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
